/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Partner_Add_Customer_Contract_PrepaidInputs */



/**
* | output |
* | --- |
* | "Prepaid usage (EUR)" |
*
* @param {Partner_Add_Customer_Contract_PrepaidInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const partner_add_customer_contract_prepaid = /** @type {((inputs?: Partner_Add_Customer_Contract_PrepaidInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Partner_Add_Customer_Contract_PrepaidInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Vorausbezahlte Nutzung (EUR)")
	return /** @type {LocalizedString} */ ("Prepaid usage (EUR)")
});